import { css, Theme, useTheme, SerializedStyles } from '@emotion/react'
import { FieldValidator } from 'final-form'
import { FC } from 'react'
import { Field } from 'react-final-form'

import useFormStyles from '~/form/hooks/useFormStyles'

type Props = {
  isShowError?: boolean
  name: string
  type?: string
  htmlFor?: string
  placeholder?: string
  ariaLabel?: string
  parse?: (value: string, name: string) => string
  validate?: FieldValidator<string>
}

const InputText: FC<Props> = ({
  name,
  isShowError = false,
  type = 'text',
  htmlFor,
  placeholder,
  ariaLabel,
  parse,
  validate,
}) => {
  const theme = useTheme()

  const { placeholderStyle } = useFormStyles()

  return (
    <div
      css={[
        textFieldStyle(theme, placeholderStyle),
        isShowError && textFieldErrorStyle(theme),
      ]}
    >
      <Field
        id={htmlFor}
        name={name}
        type={type}
        component='input'
        placeholder={placeholder}
        aria-label={ariaLabel}
        validate={validate}
        parse={parse}
      />
    </div>
  )
}

export default InputText

const textFieldStyle = (
  theme: Theme,
  placeholderStyle: SerializedStyles
) => css`
  font-size: 14px;

  input {
    color: ${theme.color.black};
    padding: 5px 13px;
    border: 2px solid transparent;
    border-radius: 10px;
    background-color: #fff;
    width: 100%;
    font-size: inherit;
    line-height: 1.7;
    ${placeholderStyle}

    &:focus {
      transition: box-shadow 400ms cubic-bezier(0.215, 0.61, 0.355, 1);
      box-shadow: 0 0 0 2px ${theme.color.yellow};
    }
  }
`

const textFieldErrorStyle = (theme: Theme) => css`
  input {
    border-color: ${theme.color.red};
    background: #fbebeb;
  }
`
